import { createSlice } from "@reduxjs/toolkit";
import i18n from "../../../../i18n";

const getInitialBreadcrumbs = () => [
  { title: "EyeHub", link: "/" },
  { title: i18n.t("breadcrumbs.home", { ns: "common" }), link: "#" },
];

const initialState = {
  title: null,
  breadcrumbItems: getInitialBreadcrumbs(),
};

const breadcrumbSlice = createSlice({
  name: "breadcrumb",
  initialState,
  reducers: {
    setBreadcrumbItems(state, action) {
      const { title, items } = action.payload;
      state.title = title;
      state.breadcrumbItems = items;
    },
  },
});

export default breadcrumbSlice.reducer;

export const { setBreadcrumbItems } = breadcrumbSlice.actions;
